import React from 'react';
import { Button } from './ui/Button';
export function Header() {
  return <header className="w-full py-4 px-6 md:px-10 lg:px-20 flex justify-between items-center border-b border-gray-800" data-id="element-120">
      <div className="text-xl font-bold tracking-wider" data-id="element-121">
        <span className="text-[#00E0FF]" data-id="element-122">CRITICAL</span>
        <span className="ml-2" data-id="element-123">VOICE</span>
      </div>
      <nav className="hidden md:flex items-center space-x-8" data-id="element-124">
        <a href="#what-it-is" className="text-sm uppercase tracking-wider hover:text-[#00E0FF] transition-colors" data-id="element-125">
          About
        </a>
        <a href="#use-cases" className="text-sm uppercase tracking-wider hover:text-[#00E0FF] transition-colors" data-id="element-126">
          Use Cases
        </a>
        <a href="#how-to-get-it" className="text-sm uppercase tracking-wider hover:text-[#00E0FF] transition-colors" data-id="element-127">
          Pricing
        </a>
      </nav>
      <a href="https://ai-therapist-production.up.railway.app/" target="_blank" rel="noopener noreferrer" data-id="element-128">
        <Button data-id="element-129">Get Access</Button>
      </a>
    </header>;
}